import api from "./api";

const transactionSlipService = {
    get: (jwttoken) =>
        api.get(`/transaction-slip`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
};

export default transactionSlipService;